import React from 'react'

export default function IcoCard( props ) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      { ...props }
    >
      <rect
        height="14"
        rx="2.5"
        width="19"
        x="2.5"
        y="5"
      />
      <path d="M2.5 9.5h19" />
      <path d="M6 15.5h4" />
    </svg>
  )
}
